// extracted by mini-css-extract-plugin
export default {"cursor-pointer":"loginForm_cursor-pointer__5q1IE"};